import React from 'react';
import { ReviewContextType } from '../../../propTypes';

const ReviewCoverSheetFields = ({ reviewContext }) => {
  const { contact, fields } = reviewContext;

  const sections = [
    { name: 'Demographic', fields: fields.filter(f => f.section === 'demographic') },
    { name: 'Key Information', fields: fields.filter(f => f.section === 'key_information') },
  ].filter(section => section.fields.length !== 0);

  return (
    <div className='review-cover-sheet-fields row'>
      {sections.map(({ name, fields }) => (
        <div className='review-cover-sheet-fields-section col-12' key={name}>
          <h2>{name}</h2>

          {fields.map(field => (
            <div className='review-cover-sheet-field row' key={field.name}>
              <div className='col-lg-10'>
                <div className='review-cover-sheet-field-name'>{field.display_name}</div>
              </div>
              <div className='col-lg-14'>
                { (field.name === 'review_comments'
                  || (field.name.startsWith('calendar_') && field.name.endsWith('_date')))
                  ? <div className='review-cover-sheet-field-value' dangerouslySetInnerHTML={{ __html: contact[field.name] }} />
                  : <div className='review-cover-sheet-field-value'>{contact[field.name]}</div> }
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

ReviewCoverSheetFields.propTypes = {
  reviewContext: ReviewContextType.isRequired,
};

export default ReviewCoverSheetFields;
